(function () {

    'use strict';

    function pxAddRemoveNetworks(
        $rootScope, $timeout, NetworkListPOSTPaging, NetworkListService
    ) {
        return {
            restrict: 'EA',
            scope: {
                selectedNetworksIn: '=',
                availableNetworks: '=',
                onApply: '&',
                onCancel: '&'
            },
            templateUrl: 'app/directives/addRemoveNetworksDirective/add-remove-networks.template.html',
            link: function (scope) {
                scope.networks = [];
                scope.selectedNetworks = angular.copy(scope.selectedNetworksIn);
                scope.searchString = '';
                scope.networkListPaging = new NetworkListPOSTPaging();

                scope.textSearch = function () {
                    scope.networkListPaging.pagingCriteria.match = scope.searchString;
                    if (!scope.availableNetworks) {
                        getFirstPage();
                    }
                };

                scope.selectNetwork = function (network) {
                    network.options.isSelected = true;
                    scope.selectedNetworks.push({
                        id: network.customProperties.id,
                        name: network.info.name
                    });
                };

                scope.deselectNetwork = function (selectedNetwork) {
                    scope.selectedNetworks.splice(scope.selectedNetworks.indexOf(selectedNetwork), 1);
                    let network = scope.networks.find(n => n.info._links.self.href.endsWith(selectedNetwork.id));
                    if (network) {
                        network.options.isSelected = false;
                    }
                };

                scope.onDoneButtonClick = function () {
                    scope.onApply({ selectedNetworks: scope.selectedNetworks });
                };

                scope.onCloseButtonClick = function () {
                    scope.onCancel();
                };

                scope.$on('$destroy', function () {
                    unregisterScrollHandler();
                });

                function markSelectedNetworks() {
                    scope.networks.forEach(network => {
                        if (scope.selectedNetworks.some(sn => sn.id === network.customProperties.id)) {
                            network.options.isSelected = true;
                        }
                    });
                }

                function getFirstPage() {
                    scope.networkListPaging.pagingCriteria.page = 0;
                    scope.networkListPaging.pagingCriteria.networkTypeFilter = ['OFFICE'];

                    scope.loadingPage = true;
                    NetworkListService.getNetworkListPagedByPost(scope.networkListPaging).then(function (response) {
                        window.scrollTo(0, 0);
                        scope.totalPages = response.page.totalPages;
                        scope.networks = response.list;
                        scope.loadingPage = false;
                        markSelectedNetworks();
                    }).catch(function(error){
                        scope.networks = [];
                        scope.loadingPage = false;
                    });
                }

                function getNextPage() {
                    if (!scope.loadingPage && scope.networkListPaging.pagingCriteria.page < scope.totalPages - 1) {
                        scope.networkListPaging.pagingCriteria.page += 1;

                        scope.loadingPage = true;
                        NetworkListService.getNetworkListPagedByPost(scope.networkListPaging).then(function (response) {
                            if (response.list) {
                                scope.networks = scope.networks.concat(response.list);
                                markSelectedNetworks();
                            }
                            scope.loadingPage = false;
                        }).catch(function(error){
                            scope.loadingPage = false;
                        });
                    }
                }

                function scrollHandler(event) {
                    if (!scope.loadingPage && scope.networkListPaging.pagingCriteria.page + 1 < scope.totalPages) {
                        let scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
                        let containerHeight = event.currentTarget.scrollHeight;
                        if (scrollEnd >= containerHeight) {
                            $timeout(function () {
                                getNextPage();
                            }, 300);
                        }
                    }
                }

                function registerScrollHandler() {
                    angular.element('.pagination-content').on('scroll', scrollHandler);
                }

                function unregisterScrollHandler() {
                    angular.element('.pagination-content').off('scroll', scrollHandler);
                }

                (function () {
                    if (scope.availableNetworks) {
                        scope.networks = scope.availableNetworks;
                        markSelectedNetworks();
                    } else {
                        getFirstPage();
                        registerScrollHandler();
                    }
                })();

            }
        };
    }

    pxAddRemoveNetworks.$inject = ['$rootScope', '$timeout', 'NetworkListPOSTPaging', 'NetworkListService'];

    angular
        .module('printix-admin')
        .directive('pxAddRemoveNetworks', pxAddRemoveNetworks);

})();
